import React, { useState } from "react";

import _ from "lodash";

import {
  CircularProgress,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from "@material-ui/core";

import {
  fetchRelatedRecords,
  useDataProvider,
  useNotify,
  useListContext,
  useResourceContext,
} from "ra-core";
import { Button } from "react-admin";

import { logError } from "../../utils/appUtils";
import { MAX_INVENTORY_QUERY_LIMIT } from "../../utils/constants";
import { ExportIcon } from "./iconography";

const BaseExport = ({
  onClick,
  exporter: customExporter,
  disabled: disabledProp,
  renderView,
  onLoadingChange,
  ...rest
}) => {
  const {
    payload,
    filter,
    filterValues,
    exporter: exporterFromContext,
    total,
    ids,
  } = useListContext(rest);
  const perPage = MAX_INVENTORY_QUERY_LIMIT - 51; // fixed perPage to avoid querySignature duplicates
  const resource = useResourceContext(rest);
  const exporter = customExporter || exporterFromContext;
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);

  const handleClick = async (event) => {
    if (typeof onClick === "function") {
      onClick(event);
    }
    setLoading(true);
    if (typeof onLoadingChange === "function") {
      onLoadingChange(true);
    }
    debugger;

    try {
      let data = [];

      if (total !== 0 || ids.length !== 0) {
        let page = 1;
        let runningTotal = 0;

        const combinedFilter = filter
          ? { ...filterValues, ...filter }
          : filterValues;

        // using sort causes duplicate records in the export
        // elasticsearch requires deterministic sort to avoid duplicate records in the export
        // cannot use column that is not unique like receivedAt, lotNumber, etc.
        // must use id as a stable tie-breaker
        // const sort = { field: "id", order: "asc" };
        let response = await dataProvider.getList(resource, {
          sort: {}, // removed sort to eliminate duplicates (DataProvider querySignature)
          filter: combinedFilter,
          pagination: { page: page, perPage: perPage },
        });
        data = data.concat(response.data);
        runningTotal = response.data.length;

        while (response.total > runningTotal) {
          page++;
          response = await dataProvider.getList(resource, {
            sort: {}, // removed sort to eliminate duplicates (DataProvider querySignature)
            filter: combinedFilter,
            pagination: { page: page, perPage: perPage },
          });
          data = data.concat(response.data);
          runningTotal += response.data.length;
        }
      }

      const filterKeys = Object.keys(filter);
      const isKeyQuery = filterKeys.includes(payload.sort.field);
      if (!isKeyQuery) {
        data = _.orderBy(
          data,
          [payload.sort?.field || "id"],
          [payload.sort?.order?.toLowerCase() || "asc"],
        );
      }

      // Sort by receivedAt (asc), with id as a stable tie-breaker
      exporter &&
        (await exporter(
          data,
          fetchRelatedRecords(dataProvider),
          dataProvider,
          resource,
          filter,
        ));
    } catch (error) {
      logError("common:BaseExport:handleClick", error, notify);
    } finally {
      setLoading(false);
      if (typeof onLoadingChange === "function") {
        onLoadingChange(false);
      }
    }
  };

  return renderView({
    handleClick,
    loading,
    disabled: disabledProp || total === 0 || ids.length === 0 || loading,
    ...rest,
  });
};

const ExportButton = (props) => (
  <BaseExport
    {...props}
    renderView={({ handleClick, loading, disabled }) => (
      <Button
        label={props.label || "ra.action.export"}
        disabled={disabled}
        onClick={handleClick}
      >
        {loading ? (
          <CircularProgress color="inherit" size={17} />
        ) : (
          <ExportIcon />
        )}
      </Button>
    )}
  />
);

export const ExportMenuItem = ({ label, icon, children, ...props }) => (
  <BaseExport
    {...props}
    renderView={({ handleClick, disabled }) => (
      <MenuItem disabled={disabled} onClick={handleClick}>
        {icon && <ListItemIcon>{icon}</ListItemIcon>}
        <ListItemText primary={label} />
        {children}
      </MenuItem>
    )}
  />
);

export default ExportButton;
